import { gql } from 'apollo-angular';

export const MUTATION_UPSERT_WARRANTY_CERTIFICATE = gql`
  mutation upsertWarrantyCertificate($input: UpsertWarrantyCertificateDto!) {
    upsertWarrantyCertificate(input: $input) {
      id
      name
      description
      manufacturer
      status
    }
  }
`;
